export default __webpack_public_path__ + "static/N0301-baa8a2c0007f08976e5a0907393d0621.png";